/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import {
  MODEL_TYPE_1_ID,
  MODEL_TYPE_2_ID,
} from '@hbrisk/sp3-risk-model-support/models/modelTypes/ids.js';

// Only these types can be extracted from a document, so only these route through the upload
// decision step (HBR-4950 #316) / upload interstitial. Site Hazards (type 3) is not an ASCE 41
// building evaluation and has no `aiExposed` field definitions -- it goes straight into the model
// page, with no extraction step offered. Shared by ModelTypes and Dashboard/CreateModelButton so
// the single-type shortcut applies the same type filter as multi-type selection.
export const EXTRACTION_CAPABLE_TYPES = [MODEL_TYPE_1_ID, MODEL_TYPE_2_ID];
